import { createFileRoute } from '@tanstack/react-router';
import Security from '../../../profile/src/components/Security';

export const Route = createFileRoute('/_secured/profile/security')({
  component: Security,
});
